var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$apollo.loading)?_c('div',{staticClass:"banner",class:_vm.size,on:{"click":function($event){return _vm.$router.push({ name: 'promotions.holidayActivities' })}}},[_c('div',{staticClass:"img",class:_vm.size})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-700f027a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/promotions/holidayActivities/HomepageBanner.vue
// module id = null
// module chunks = 